var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17C10.0508 17.0014 11.0915 16.795 12.0622 16.3929C13.033 15.9908 13.9148 15.4008 14.6568 14.6568C15.4008 13.9148 15.9908 13.033 16.3929 12.0622C16.795 11.0915 17.0014 10.0508 17 9C17.0013 7.94923 16.795 6.90855 16.3929 5.93777C15.9908 4.96699 15.4008 4.08525 14.6568 3.3432C13.9148 2.59922 13.033 2.00921 12.0622 1.60708C11.0915 1.20496 10.0508 0.998645 9 1.00001C7.94923 0.998667 6.90855 1.20499 5.93777 1.60711C4.96699 2.00923 4.08525 2.59923 3.3432 3.3432C2.59923 4.08525 2.00923 4.96699 1.60711 5.93777C1.20499 6.90855 0.998667 7.94923 1.00001 9C0.998645 10.0508 1.20496 11.0915 1.60708 12.0622C2.00921 13.033 2.59922 13.9148 3.3432 14.6568C4.08525 15.4008 4.96699 15.9908 5.93777 16.3929C6.90855 16.795 7.94923 17.0013 9 17Z",
    stroke: "#5DB65B",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79688 9.00156L8.19687 11.4016L12.9969 6.60156",
    stroke: "#5DB65B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.bc1690d65abceea616462109772bc2a2.svg";
export { ForwardRef as ReactComponent };